import { c as _c } from "react/compiler-runtime";
import { Padding, colors, Text, Flexbox, IconLocationPin } from '@newfront-insurance/core-ui';
import * as React from 'react';
import type { JSX } from 'react';
import styled from 'styled-components';
import type { Suggestion, Address } from '../../../types';
import { transformSmartyStreetsLookupToAddress } from '../../../utils/format-street-address';
import { HighlightQueryInText } from '../highlight-query-in-text';
interface Props {
  suggestion: Suggestion;
  handleSelectedResult: (address: Address) => unknown;
  onKeyDown: (event: React.KeyboardEvent<Element>) => void;
  addressQuery?: string;
}
export function LookupAddress(t0) {
  const $ = _c(34);
  const {
    onKeyDown,
    suggestion,
    handleSelectedResult,
    addressQuery
  } = t0;
  let t1;
  if ($[0] !== suggestion) {
    t1 = transformSmartyStreetsLookupToAddress(suggestion);
    $[0] = suggestion;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const address = t1;
  const {
    addressLine1,
    addressLine2,
    addressLine3,
    city,
    stateOrArea,
    countryCode,
    postalCode
  } = address;
  let t2;
  if ($[2] !== address || $[3] !== handleSelectedResult) {
    t2 = () => handleSelectedResult(address);
    $[2] = address;
    $[3] = handleSelectedResult;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== address || $[6] !== handleSelectedResult || $[7] !== onKeyDown) {
    t3 = e => {
      if (e.key === "Enter") {
        handleSelectedResult(address as Address);
        return;
      }
      onKeyDown(e);
    };
    $[5] = address;
    $[6] = handleSelectedResult;
    $[7] = onKeyDown;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      lineHeight: 1
    };
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Padding right={12}><IconLocationPin size={14} color="#98A6B5" /></Padding>;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== addressLine1 || $[12] !== addressQuery) {
    t6 = <HighlightQueryInText text={addressLine1} query={addressQuery} />;
    $[11] = addressLine1;
    $[12] = addressQuery;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== addressLine2) {
    t7 = addressLine2 && <div>{addressLine2}</div>;
    $[14] = addressLine2;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== addressLine3) {
    t8 = addressLine3 && <div>{addressLine3}</div>;
    $[16] = addressLine3;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
    t9 = <Padding bottom={4}>{t6}{t7}{t8}</Padding>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== city || $[23] !== countryCode || $[24] !== postalCode || $[25] !== stateOrArea) {
    t10 = <div>{city}, {stateOrArea}, {postalCode}, {countryCode}</div>;
    $[22] = city;
    $[23] = countryCode;
    $[24] = postalCode;
    $[25] = stateOrArea;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t9) {
    t11 = <Text size="small" color="inherit" style={t4}><Padding y={8} x={16}><Flexbox>{t5}<div>{t9}{t10}</div></Flexbox></Padding></Text>;
    $[27] = t10;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t11 || $[31] !== t2 || $[32] !== t3) {
    t12 = <StyledResult tabIndex={0} className="lookup-result" onClick={t2} onKeyDown={t3} data-lookup-result={true}>{t11}</StyledResult>;
    $[30] = t11;
    $[31] = t2;
    $[32] = t3;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  return t12;
}
const StyledResult = styled.div`
  line-height: 1;

  &:hover,
  &:focus {
    background-color: ${colors.brand[400]};
    cursor: pointer;
    color: #fff;
  }

  &:hover > span path,
  &:focus > span path {
    fill: #fff;
  }
`;